export enum ETimelineTimeframe {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export const FILLED_TIMELINE_ELEMENT_KEY = 'filled_timeline_element';
